<template>
  <div class="register">
    <div class="main-content">
      <div class="page-width">
        <div class="section-header text-center">
          <h2>{{ $t('createAccount') }}</h2>
          <!-- <h4>{{ errorMessage }}</h4> -->
        </div>
        <el-form :label-position="labelPosition" label-width="80px" :model="formRegister">
          <p v-if="errors.length" style='padding-bottom: 20px'>
            <b>{{ $t('followingErrors') }}</b>
            <ul style="color: red">
              <li v-for="error in errors">{{ error }}</li>
            </ul>
          </p>
          <!-- <el-form-item label="First Name"> -->
          <el-form-item v-bind:label="$t('customerName')">
            <el-input v-model="formRegister.FirstName" ></el-input>
          </el-form-item>
          <el-form-item v-bind:label="$t('companyName')">
            <el-input v-model="formRegister.companyName" ></el-input>
          </el-form-item>
          <el-form-item v-bind:label="$t('phone')">
            <el-input v-model="formRegister.phone" ></el-input>
          </el-form-item>
          <el-form-item v-bind:label="$t('email')">
            <el-input v-model="formRegister.email" ></el-input>
          </el-form-item>
          <el-form-item v-bind:label="$t('password')">
            <el-input v-model="formRegister.password" type="password" ></el-input>
          </el-form-item>
          <!-- <div v-bind:style="{ display: 'flex', 'justify-content': 'center', 'align-items': 'center' }">
            <div style="display: table; margin: 0 auto;">
              <input type="checkbox" id="read" value="read" v-model="read">
              <label for="read">条款声明</label>
            </div>
          </div> -->
          <div class="text-center">
          <el-button class="btn" type="submit" @click="register(formRegister)">{{ $t('create') }}</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Router from '../../router'
export default {
  name: "register",
  data() {
    return {
      // read: false,
      errors: [],
      labelPosition: 'top',
      formRegister: {
        FirstName: '',
        LastName: '',
        email: '',
        phone: '',
        password:'',
        username: '',
        companyName: '',
      }
    }
  },
  methods: {
    ...mapActions('auth', ['registerRequest', 'checkUsername', 'checkEmail', 'LoginRequest']),
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    checkForm: async function (form) {
      this.errors = [];
      const usernameBeenTaken = await this.checkUsername({ username: form.username });
      if(!form.FirstName) {
      this.errors.push(this.$t('firstNameRequired'))
      };
      // if(!form.LastName) {
      //   this.errors.push(this.$t('lastNameRequired'))
      // };
      if(form.password.length < 8) {
        this.errors.push(this.$t('passwordLengthRequired'))
      }
      // if(form.companyName.length < 5) {
      //   this.errors.push(this.$t('usernameLengthRequired'));
      // }
      if(usernameBeenTaken.data.isTaken) {
        this.errors.push(this.$t('usernameTaken'))
      }
      if(form.phone.length < 5) {
        this.errors.push(this.$t('phoneNumberRequired'));
      }
      if (!form.email) {
        this.errors.push(this.$t('emailRequired'));
      } else if (!this.validEmail(form.email)) {
        this.errors.push(this.$t('emailValidRequired'));
      }else {
        const res = await this.checkEmail({ email: form.email })
        if(res.data.isTaken) {
          this.errors.push(this.$t('emailTaken'))
        }
      }        
    },
    register: async function(form) {
      await this.checkForm(form);
      form.username = form.email;
      const test = {
        "email":"newtest@gmail.com",
        "customer_num":"M-000012"
      };
      this.openAlert(test);
      // if(!this.errors.length) {
      //   this.registerRequest(form)
      //   .then(res => {
      //     this.openAlert(res.data);
      //     // this.LoginRequest({username: form.username, password: form.password});
      //   })
      //   .catch( err => {
      //     this.errors = [];
      //     this.errors.push(this.$t('errorCreateAccount'));
      //   })
      // }
    },
    openAlert(info) {
      let message = "用户名：" + info.email + ' \n' +
      "客户ID: " + info.customer_num + ' \n' +
      "请联系客服审核通过账户";
      
      console.log('message: ', message);
      this.$alert(message, "注册成功!", {
        confirmButtonText: "Ok",
        type: "success",
        center: true,
      }).then(() => {
        this.$router.push('/login');
      });
    },
  },
  computed: mapState({
    errorMessage: state => state.auth.registerErrorMessage
  })
}
</script>

<style scoped lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/register.less";
</style>



// WEBPACK FOOTER //
// src/view/Auth/register.vue